/*
*
* File JS per l'archivio Press
*
*/


// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSimple from 'components/hero-simple/hero-simple';
import cardPress from 'components/cards/card-press';

import archiveFilters from 'components/archive-filters/archive-filters';
import pagination from 'components/pagination/pagination';

import menuCategory from 'components/menu-category/menu-category';
import featuredBrands from 'components/featured-brands/featured-brands';

//--------------------------------------------------------------------//


// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './archive-press.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//